import { BaseResource as Resource } from '../defaults/resource'
import withMessages from './with-messages'

export default {
  mixins: [ withMessages ],
  validate ({ route, redirect }) {
    if (route.path !== '/' && route.path.endsWith('/')) {
      return redirect({
        ...route,
        path: route.path.slice(0, -1)
      })
    }
    return true
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$cms) { return next() }
    this.notifyRouteChange(to, from)
  },
  beforeRouteUpdate (to, from, next) {
    if (!this.$cms) { return next() }
    this.notifyRouteChange(to, from)
  },
  computed: {
    resource () {
      const path = this.$route.path
      return Resource.query().with('children', (query) => {
        query.orderBy('sort_key')
      }).where('url', path).first()
    }
  },
  mounted () {
    if (!this.$cms && !this.resource) {
      return this.$nuxt.error({ statusCode: 404, message: 'Die von Ihnen angefordertete Seite konnte leider nicht gefunden werden.' })
    }
  },
  methods: {
    notifyRouteChange (to, from) {
      this.routeChangedMessage({
        to: to.path,
        from: from.path
      })
    }
  }
}
